import {
  DrillHoleObject,
  ProjectAllReport,
  ProjectModel,
} from '../TypeScript/interfaces';
import { createContext } from 'react';

export interface DrillholeContextType {
  drillholesMap: DrillholesMap;
  drillholesMapReady: boolean;
  hardReloadDrillholesMap: () => void;
  projectReports: ProjectAllReport[] | [];
  setProjectReports: (value: ProjectAllReport[] | []) => void;
  hardReloadProjectReportsAndModels: () => void;
  reloadOneDrillhole: (drillholeId: number) => void;
  projectModels: ProjectModel[];
  projectModelsLoading: boolean;
}

export interface DrillholesMap {
  byId: Record<string | number, DrillHoleObject>;
  byName: Record<string, DrillHoleObject>;
  byQuery: Record<string, DrillHoleObject[]>;
}

export const emptyDrillholesMap: DrillholesMap = {
  byId: {},
  byName: {},
  byQuery: {},
};

export const DrillholeContext = createContext<DrillholeContextType>({
  drillholesMap: emptyDrillholesMap,
  drillholesMapReady: false,
  hardReloadDrillholesMap: (): void => {},
  projectReports: [] as ProjectAllReport[] | [],
  setProjectReports: (value: ProjectAllReport[]): void => {},
  projectModels: [],
  projectModelsLoading: true,
  hardReloadProjectReportsAndModels: (): void => {},
  reloadOneDrillhole: (drillholeId: number): void => {},
});
